import { useQuery } from "@tanstack/react-query";

import { financeOverviewQueryKey } from "../config";
import { fetchFinanceOverviewWorkbench } from "../repo/financeOverviewRepo";

/** 财务工作台：一次取两张总数卡和三类待办的件数；没有那一页权限的项接口不给（为 null）。 */
export function useFinanceOverviewWorkbenchRuntime() {
  const workbench = useQuery({
    queryKey: [...financeOverviewQueryKey, "workbench"],
    queryFn: fetchFinanceOverviewWorkbench,
    retry: false,
    refetchOnWindowFocus: false,
  });
  return {
    data: workbench.data ?? null,
    loading: workbench.isFetching,
    failed: workbench.isError,
    refresh() {
      void workbench.refetch();
    },
  };
}
